import React, { useContext, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import classnames from 'classnames';
import { GolbalDataContext } from '../../components/store/global-data-provider';
import ConfigData from "../../config.json";
import SingleUploadfile from '../../components/common/single-uploadfile';
import { getFilterOldFileName, setFormDataUploadFile, setStringFileNameToArray } from '../../components/utils/format-value';
import StepWorkflow from '../../components/common/step-workflow';
import Swal from 'sweetalert2';
import { IconAlertSuccess, IconAlertError, IconDuplicateEmail, IconLoading } from '../../components/common/popup-alert';
import MultipleDownloadfile from '../../components/common/multiple-downloadfile';
import AssignDetailCsa from '../../components/assign/assign-detail-csa';
import AssignDetailNda from '../../components/assign/assign-detail-nda';
import AssignDetailLdr from '../../components/assign/assign-detail-ldr';
import AssignDetailDbd from '../../components/assign/assign-detail-dbd';
import AssignDetailPoa from '../../components/assign/assign-detail-poa';
import RequestHistory from '../../components/request/request-history';


const PrefinalContractLegal = () => {
    const { id } = useParams();
    const history = useHistory();
    const { changeTitlePage } = useContext(GolbalDataContext);
    const [customActiveTab, setcustomActiveTab] = useState("2");
    const [formIsDisabled, setFormIsDisabled] = useState(false);
    const [dataRequestDetail, setDataRequestDetail] = useState([]);
    const [dataRequestFormDetail, setDataRequestFormDetail] = useState([]);
    const [dataRequestHistory, setDataRequestHistory] = useState([]);
    const [fileLegalFinalDoc, setFileLegalFinalDoc] = useState([]);
    const [fileMemo, setFileMemo] = useState([]);
    const [dataRequest, setDataRequest] = useState({
        "id": 0,
        "request_no": "",
        "final_doc": "",
        "select_legal_approve_by": "",
        "legal1_approve_by": "",
        "legal2_approve_by": "",
        "legal3_approve_by": "",
        "note": "",
        "send_to": ""
    });
    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    useEffect(() => {
        changeTitlePage("All Request");
        let strId = "0";
        try{
            strId = atob(id);
        }catch(error){
            strId = "0"
        }
        LoadUserCanDoReq(strId);
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataRequest.id || 0,
            request_no: dataRequest.request_no || "",
            final_doc: dataRequest.final_doc || "",
            select_legal_approve_by: dataRequest.select_legal_approve_by || "",
            legal1_approve_by: dataRequest.legal1_approve_by || "",
            legal2_approve_by: dataRequest.legal2_approve_by || "",
            legal3_approve_by: dataRequest.legal3_approve_by || "",
            note: dataRequest.note || "",
            send_to: dataRequest.send_to || "",
        },
        validationSchema: Yup.object({
            final_doc: Yup.string().required("กรุณาแนบไฟล์ร่างเอกสารสุดท้าย/Please attach the finalized document"),
            legal1_approve_by: Yup.string().required("กรุณาระบุผู้อนุมัติขั้นสุดท้ายอย่างน้อย 1 คน/Please specify at least 1 final approver.").email("Please enter a Email Address.").matches(englishEmailRegex, "Email must be a valid English email address"),
            legal2_approve_by: Yup.string().email("Please enter a Email Address.").matches(englishEmailRegex, "Email must be a valid English email address"),
            legal3_approve_by: Yup.string().email("Please enter a Email Address.").matches(englishEmailRegex, "Email must be a valid English email address"),
        }),
        onSubmit: (values) => {
            // console.log(values);
            // console.log(fileLegalFinalDoc);
            SavePreFinalContactLegal(values);
        }
    });

    const OnSetFileLegalFinalDoc = (file) => {
        const fileName = (file.length > 0) ? file[0].name : "";
        setFileLegalFinalDoc(file);
        validation.handleChange('final_doc')(fileName);
        setFormIsDisabled(false);
    };

    const OnClickBack = () => {
        // history.push("/dashboard");
        history.push(GetUrlBack());
    };

    const toggleCustomActiveTab = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const showLoading = (isShow) => {
        if (isShow) {
            Swal.fire({
                iconHtml: IconLoading,
                title: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });
        } else {
            Swal.close();           
        }
    };

    const SwitchRequestDetail = () => {
        switch (dataRequestDetail.table_name?.toLowerCase()) {
            case "csa": 
                return (
                    <AssignDetailCsa 
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "nda": 
                return (
                    <AssignDetailNda
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "ldr": 
                return (
                    <AssignDetailLdr
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "dbd": 
                return (
                    <AssignDetailDbd
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "poa": 
                return (
                    <AssignDetailPoa
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            default: 
                return (
                    <div></div>
                );
        }
    };

    const SetAndCheckEmail = (inputValue, inputName) => {
        // console.log(validation.values.legal1_approve_by, validation.values.legal2_approve_by, validation.values.legal3_approve_by);
        const objApproveBy = { 
            "legal1_approve_by": validation.values.legal1_approve_by,
            "legal2_approve_by": validation.values.legal2_approve_by,
            "legal3_approve_by": validation.values.legal3_approve_by 
        };
        const updatedForm = { ...objApproveBy, [inputName]: inputValue };
        const values = Object.values(updatedForm).filter((v) => v !== ""); // กรองค่าว่าง
        const uniqueValues = new Set(values);

        if(values.length !== uniqueValues.size){
            validation.handleChange(inputName)("");
            Swal.fire({
                iconHtml: IconDuplicateEmail,
                title: "ผู้อนุมัติท่านนี้ ได้ถูกเลือกแล้ว\nThis approver has already been selected.",
                showConfirmButton: false,
                showCloseButton: true,
            });

        }else{
            validation.handleChange(inputName)(inputValue);
        }
    };

    const GetUrlBack = () => {
        const urlBack = (dataRequestDetail.table_name !== "" && dataRequestDetail.table_name !== null && dataRequestDetail.table_name !== undefined) ? "/request-form/" + btoa(dataRequestDetail.table_name) : "/all-type-request";
        return urlBack;
    };

    const LoadDataRequest = (id) => {
        let url = ConfigData.API_URL + "request/" + id ;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const objData = {
                    "id": respData.data[0].id,
                    "request_no": respData.data[0].request_no,
                    "final_doc": respData.data[0].final_doc,
                    "select_legal_approve_by": respData.data[0].select_legal_approve_by,
                    "legal1_approve_by": respData.data[0].legal1_approve_by,
                    "legal2_approve_by": respData.data[0].legal2_approve_by,
                    "legal3_approve_by": respData.data[0].legal3_approve_by,
                    "send_to": respData.data[0].request_by,
                    "note": ""
                };
                LoadDataReqWorkflowStatus(respData.data[0].id, 16, objData);
                setFileLegalFinalDoc(setStringFileNameToArray(objData.final_doc));
                setFileMemo([{"name": respData.data[0].memo_doc}]);
                setDataRequestDetail(respData.data[0]);
                if( respData.data[0].table_name?.toLowerCase() === "csa" ){
                    LoadDataRequestForm(respData.data[0].id, "csa");
                } else if( respData.data[0].table_name?.toLowerCase() === "nda" ){
                    LoadDataRequestForm(respData.data[0].id, "nda");
                } else if( respData.data[0].table_name?.toLowerCase() === "ldr" ){
                    LoadDataRequestForm(respData.data[0].id, "ldr");
                } else if( respData.data[0].table_name?.toLowerCase() === "dbd" ){
                    LoadDataRequestForm(respData.data[0].id, "dbd");
                } else if( respData.data[0].table_name?.toLowerCase() === "poa" ){
                    LoadDataRequestForm(respData.data[0].id, "poa");
                }
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataReqWorkflowStatus = (idReq, idWorkflowStatus, objReq) => {
        let url = ConfigData.API_URL + "request-workflow/search?status=1&idRequest=" + idReq  + "&idWorkflowStatus=" + idWorkflowStatus;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                objReq.note = respData.data[0].comment;
            }
            setDataRequest(objReq);
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
            setDataRequest(objReq);
        });
    };

    const LoadDataRequestForm = (idRequests, formName) => {
        let url;
        if( formName === "csa" ){
            url = ConfigData.API_URL + "form-csa/request/" + idRequests;
        } else if( formName === "nda" ){
            url = ConfigData.API_URL + "form-nda/request/" + idRequests;
        } else if( formName === "ldr" ){
            url = ConfigData.API_URL + "form-ldr/request/" + idRequests;
        } else if( formName === "dbd" ){
            url = ConfigData.API_URL + "form-dbd/request/" + idRequests;
        } else if( formName === "poa" ){
            url = ConfigData.API_URL + "form-poa/request/" + idRequests;
        }

        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const arrData = respData.data[0];
                setDataRequestFormDetail(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadUserCanDoReq = (id) => {
        let userDo = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let url = new URL(ConfigData.API_URL + "request/user-can-do");
        url.searchParams.set("email", userDo);
        url.searchParams.set("id-request", id);
        url.searchParams.set("id-workflow", "15"); 
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const arrUserDo = respData.data[0].user_do_request.split(",");
                if(arrUserDo.find((e) => e === userDo) !== undefined){
                    LoadDataRequest(id);
                    LoadRequestHistory(id); 
                }else{
                    history.push("/summary-request/" + btoa(id));
                }
            }else{
                // history.push("/dashboard");
                history.push(GetUrlBack());
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadRequestHistory = (idReq) => {
        let url = ConfigData.API_URL + "request-workflow/search?status=1&idRequest=" + idReq;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },responseType: "json",
        }).then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setDataRequestHistory(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const SavePreFinalContactLegal = (values) => {
        if (values.id > 0) {
            showLoading(true);
            let isSaveSucess = true;
            (async () => {
                const realTimeWorkFlow = await GetCheckRequestWorkFlow(atob(id));

                if (realTimeWorkFlow?.id_workflow_status === 16) {
                    showLoading(false);
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "The legal team has successfully completed this step. Please review it once again.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    }).then(() => {
                        history.push(GetUrlBack());
                    });
                } else {
                    let isSaveFinalContractLegal = await UpdateFinalContractLegal(values);
                    isSaveSucess = (isSaveFinalContractLegal && isSaveSucess);

                    let isSaveReqWorkflowStatus = await AddWorkFlowStaus(values);
                    isSaveSucess = (isSaveReqWorkflowStatus && isSaveSucess);

                    if (isSaveSucess) {
                        SendEmail(values);
                        showLoading(false);
                        Swal.fire({
                            iconHtml: IconAlertSuccess,
                            title: "ส่งข้อมูลให้ผู้ทำคำขอแล้ว\nSubmitted the information sending to User",
                            showConfirmButton: false,
                            showCloseButton: true,
                        }).then(() => {
                            history.push(GetUrlBack());
                        });
                    }else{
                        showLoading(false);
                    }
                }
            })();
        }
    };

    const UpdateFinalContractLegal = async (dataReq) => {
        const url = ConfigData.API_URL + "request/prefilnal-by-legal/" + dataReq.id;
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let formData = new FormData();
        formData.append("request_no", dataReq.request_no);
        formData.append("n_final_doc", getFilterOldFileName(fileLegalFinalDoc));
        formData.append("select_legal_approve_by", userId);
        formData.append("legal1_approve_by", dataReq.legal1_approve_by);
        formData.append("legal2_approve_by", dataReq.legal2_approve_by);
        formData.append("legal3_approve_by", dataReq.legal3_approve_by);
        formData = setFormDataUploadFile(formData, "f_final_doc", fileLegalFinalDoc);
        try{
            const resp = await axios.put(url, formData, { headers: { 
                'Content-Type': 'multipart/form-data',
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }

    };

    const AddWorkFlowStaus = async (dataReq) => {
        const url = ConfigData.API_URL + "request-workflow/step";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try{
            let formData = new FormData();
            formData.append("id_request", dataReq.id);
            formData.append("id_workflow_status", "16");
            formData.append("do_by", userId);
            formData.append("send_to", dataReq.send_to);
            formData.append("comment", dataReq.note);
            const resp = await axios.post(url, formData, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }
    };

    const GetCheckRequestWorkFlow = async (requestId) => {
        let url = ConfigData.API_URL + "request/" + requestId;
        const token = "Bearer " + localStorage.getItem("tkd");
        try {
            const resp = await axios.get(url, {
                headers: {
                "Content-Type": "application/json",
                Authorization: token,
                },
                responseType: "json",
            });
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                return respData.data[0]; // คืนค่าเพื่อใช้ในการเช็ค
            }
        } catch (error) {
          console.log(error);
        }
    };

    const SendEmail = (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 19,
            "request_id": data.id,
        };
        axios.post(url, dataReq, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            // console.log(resp.data);
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="prefinal-contract-legal">
                    <Row>
                        <Col lg={12}>
                            <p className="pcl-title">Request Detail {"> " + dataRequest.request_no}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <StepWorkflow step={7} />
                        </Col>
                    </Row>
                    <Nav tabs className="nav nav-tabs nav-tabs-form nav-justified mb-3">
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "1",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("1");
                                }}
                            >
                                Request Form
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "2",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("2");
                                }}
                            >
                                Work Area
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "3",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("3");
                                }}
                            >
                                History
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent
                        activeTab={customActiveTab}
                    >
                        <TabPane tabId="1">
                            {SwitchRequestDetail()}
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className="justify-content-center pt-3">
                                <Col sm={12} md={8} lg={6}>
                                    <Form className="needs-validation"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                    >
                                        <Row className="pcl-upload-contract-div">
                                            <Col lg={12}>
                                                <p className="pcl-form-header">การจัดทำร่างเอกสารสุดท้าย (Finalizing)</p>
                                                <p className="pcl-upload-contract-label">ร่างเอกสารสุดท้ายและ เอกสารแนบ (Finalized Document and Attachment)</p>
                                                <SingleUploadfile inputID="legalFinalDoc" folder={validation.values.request_no} dataFile={fileLegalFinalDoc} setDataFile={OnSetFileLegalFinalDoc} />
                                                { validation.touched.final_doc && validation.errors.final_doc ? 
                                                    ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.final_doc}</FormFeedback> ) : false 
                                                }
                                                <p className="pcl-memo-label">Memo สำหรับเสนอลงนาม (Memo for Signing Procedure)</p>
                                                <MultipleDownloadfile folder={validation.values.request_no} dataFile={fileMemo} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <p className="pcl-form-title">
                                                    ท่านสามารถเลือกผู้อนุมัติได้ 1-3 คน โดยการอนุมัติจะถูกเรียงตามลำดับที่ท่านเลือก<br/>
                                                    (You can select 1-3 persons.The approval will be arranged according to your selection.)
                                                </p>
                                                <FormGroup>
                                                    <Label className="pcl-form-label" htmlFor="txtApprove1">1.จำเป็นต้องได้รับการอนุมัติขั้นสุดท้ายโดย (Require Final Approval From)<span className="msg-require">*</span></Label>
                                                    <Input id="txtApprove1"
                                                        name="legal1_approve_by"
                                                        placeholder="Please Input email"
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            // validation.handleChange(e);
                                                            SetAndCheckEmail(e.target.value, e.target.name);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.legal1_approve_by || ""}
                                                        invalid={ validation.touched.legal1_approve_by && validation.errors.legal1_approve_by ? true : false }    
                                                    />
                                                    { validation.touched.legal1_approve_by && validation.errors.legal1_approve_by ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.legal1_approve_by}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="pcl-form-label" htmlFor="txtApprove2">2.จำเป็นต้องได้รับการอนุมัติขั้นสุดท้ายโดย (Require Final Approval From)</Label>
                                                    <Input id="txtApprove2" 
                                                        name="legal2_approve_by"
                                                        placeholder="Please Input email"
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            // validation.handleChange(e);
                                                            SetAndCheckEmail(e.target.value, e.target.name);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.legal2_approve_by || ""}
                                                        invalid={ validation.touched.legal2_approve_by && validation.errors.legal2_approve_by ? true : false } 
                                                    />
                                                    { validation.touched.legal2_approve_by && validation.errors.legal2_approve_by ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.legal2_approve_by}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="pcl-form-label" htmlFor="txtApprove3">3.จำเป็นต้องได้รับการอนุมัติขั้นสุดท้ายโดย (Require Final Approval From)</Label>
                                                    <Input id="txtApprove3" 
                                                        name="legal3_approve_by"
                                                        placeholder="Please Input email"
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            // validation.handleChange(e);
                                                            SetAndCheckEmail(e.target.value, e.target.name);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.legal3_approve_by || ""}
                                                        invalid={ validation.touched.legal3_approve_by && validation.errors.legal3_approve_by ? true : false }
                                                    />
                                                    { validation.touched.legal3_approve_by && validation.errors.legal3_approve_by ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.legal3_approve_by}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="pcl-note-div">
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="pcl-form-label" htmlFor="txtNote">Note</Label>
                                                    <Input id="txtNote"
                                                        name="note"
                                                        placeholder="Note"
                                                        type="textarea"
                                                        rows={1}
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.note || ""}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row>
                                <Col md={12}>
                                    <div className="work-area-container-tab">
                                        <div className="header-container header-content">History</div>
                                        <div className="history-container">
                                            <RequestHistory
                                                data={dataRequestHistory}
                                                column="do_date"
                                                requestNo={dataRequestDetail.request_no}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <div className="page-footer">
                            <div className="layout-width-footer">
                                <div className="navbar-footer2">
                                    <Button type="button" className="pcl-btn-back" onClick={(e) => { OnClickBack(); }}>
                                        Back
                                    </Button>
                                    <Button type="button" 
                                        color='primary' 
                                        className="pcl-btn-submit"
                                        onClick={() => validation.submitForm()}
                                        disabled={formIsDisabled || customActiveTab !== "2"}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </TabContent>
                    
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PrefinalContractLegal;

